import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

const ModalValidityUpdate = () => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.updateValidity');
  const onClose = () => {
    closeSingleModal('updateValidity');
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Atualizar validade"
      height={'auto'}
      width={'60vw'}
    >
      <Form.Validity.Validity.Update />
    </Modal>
  );
};

export default ModalValidityUpdate;
